// import home from './home';

export default {
    bgRight: require('./right-bg.png'),
};
